import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { CategoriaFinanceiraAtualizar, CategoriaFinanceiraCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import CategoriaFinanceiraController from '../../../../controllers/CategoriaFinanceiraController';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  cfi_id: number;
  cfi_idPai: number;
  cfi_descricao: string;
  cfi_tipo: string;
  BtnMenu?: JSX.Element;
}

export default function CategoriaFinanceira() {
  const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center' },
    { id: 'IdPai', label: 'IdPai', minWidth: 0 },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'Tipo', label: 'Tipo', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];

  const fields = [
    { name: 'CategoriaFinanceiraId', type: 'number', label: 'Código', col: 2 },
    { name: 'CategoriaFinanceiraIdPai', type: 'number', label: 'Código Pai', col: 2 },
    { name: 'Descricao', type: 'text', label: 'Descrição', col: 2 },
    { name: 'Tipo', type: 'number', label: 'Tipo', col: 2 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]

  const initialValues = {
    CategoriaFinanceiraId: null,
    CategoriaFinanceiraIdPai: null,
    Descricao: '',
    Tipo: '',
  };

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(CategoriaFinanceiraCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(CategoriaFinanceiraAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(CategoriaFinanceiraAtualizar.replace(':id', item.cfi_id.toString()));
    }
  };

  const handleDeleteItem = async (cfi_id: number) => {
    const request: any = { UsuId: userId, CategoriaFinanceiraId: cfi_id };
    const response = await CategoriaFinanceiraController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Categoria excluída com sucesso!', {
        type: 'success',
      });
    } else {
      toast('Erro ao excluir categoria!', {
        type: 'error',
      });
    }
    await handleSubmit(initialValues)
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await CategoriaFinanceiraController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({          
          Id: item.cfi_id,
          IdPai: item.cfi_idPai,
          Descricao: item.cfi_descricao,
          Tipo: item.cfi_tipo,
           BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () => handleDeleteItem(item.cfi_id),
                  menu: 'Excluir', confirmar: `Excluir a categoria financeira "${item.cfi_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box>
      <HeaderComponent text={'Categoria Financeira'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
